const UserSessionsSkeleton = () => {
  return (
    <div className="space-y-4">
      {[1, 2, 3].map((item) => (
        <div
          key={item}
          className="card transition-all duration-200 border rounded-lg"
        >
          <div className="p-4">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-3 flex-1">
                {/* Device Icon Skeleton */}
                <div
                  className="skeleton"
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                  }}
                ></div>
                <div className="flex-1">
                  {/* Browser/OS Skeleton */}
                  <div className="flex items-center gap-2 mb-2">
                    <div
                      className="skeleton"
                      style={{
                        width: "150px",
                        height: "20px",
                        borderRadius: "4px",
                      }}
                    ></div>
                    <div
                      className="skeleton"
                      style={{
                        width: "100px",
                        height: "16px",
                        borderRadius: "4px",
                      }}
                    ></div>
                  </div>
                  {/* Location/IP Skeleton */}
                  <div
                    className="skeleton"
                    style={{
                      width: "200px",
                      height: "16px",
                      borderRadius: "4px",
                    }}
                  ></div>
                </div>
              </div>
              {/* Action Button Skeleton */}
              <div
                className="skeleton"
                style={{
                  width: "80px",
                  height: "32px",
                  borderRadius: "4px",
                }}
              ></div>
            </div>
          </div>

          <div className="pt-0 px-3 pb-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Last Active Skeleton */}
              <div>
                <div
                  className="skeleton"
                  style={{
                    width: "180px",
                    height: "16px",
                    borderRadius: "4px",
                  }}
                ></div>
              </div>
              {/* Login Time Skeleton */}
              <div className="text-end">
                <div
                  className="skeleton"
                  style={{
                    width: "180px",
                    height: "16px",
                    borderRadius: "4px",
                    marginLeft: "auto",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserSessionsSkeleton;

